import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TokenStorageService } from 'src/app/_services/token-storage.service';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-n8n-chat',
  templateUrl: './n8n-chat.component.html',
  styleUrls: ['./n8n-chat.component.css']
})
export class N8nChatComponent implements OnInit, AfterViewInit, OnDestroy {
  private chatInitialized = false;
  private routerSubscription?: Subscription;
  private isLoggedIn = false;

  constructor(
    private router: Router,
    private tokenStorage: TokenStorageService
  ) {}

  ngOnInit(): void {
    // Prüfe Login-Status
    this.checkLoginStatus();

    // Überwache Router-Events für Login-Status
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkLoginStatus();
      });
  }

  ngAfterViewInit(): void {
    // Initialisiere Chat nach View-Init
    setTimeout(() => {
      this.initializeChat();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private checkLoginStatus(): void {
    const token = this.tokenStorage.getToken();
    const wasLoggedIn = this.isLoggedIn;
    this.isLoggedIn = !!token;

    // Wenn sich Login-Status geändert hat, initialisiere/entferne Chat
    if (this.isLoggedIn !== wasLoggedIn) {
      if (this.isLoggedIn && !this.chatInitialized) {
        setTimeout(() => {
          this.initializeChat();
        }, 500);
      } else if (!this.isLoggedIn && this.chatInitialized) {
        this.removeChat();
      }
    }
  }

  private async initializeChat(): Promise<void> {
    if (this.chatInitialized) {
      return;
    }

    const token = this.tokenStorage.getToken();
    if (!token) {
      return;
    }

    try {
      // Importiere @n8n/chat dynamisch
      // @ts-ignore - Ignoriere TypeScript-Fehler für @n8n/chat Typen
      const n8nChat = await import('@n8n/chat');
      
      if (n8nChat && n8nChat.createChat) {
        // @ts-ignore - Ignoriere TypeScript-Fehler für createChat Optionen
        n8nChat.createChat({
          webhookUrl: 'https://n8n.go4flow.de/webhook/724b9532-d65a-465f-8df6-cdbc8c540752/chat',
          target: '#n8n-chat',
          mode: 'window',
          showWelcomeScreen: true,
          loadPreviousSession: true,
          enableStreaming: true,
          i18n: {
            en: {
              title: 'Hallo! 👋',
              subtitle: 'Starten Sie einen Chat mit Kai. Wir helfen Ihnen gerne weiter.',
              footer: 'Powered by n8n',
              getStarted: 'Neue Unterhaltung',
              inputPlaceholder: 'Geben Sie Ihre Frage ein..',
              closeButtonTooltip: 'Chat schließen',
            },
          },
          initialMessages: [
            'Hallo! 👋',
            'Mein Name ist Kai. Wie kann ich Ihnen heute helfen?'
          ]
        });

        this.chatInitialized = true;
      }
    } catch (error) {
      console.error('Fehler beim Initialisieren des n8n Chats:', error);
    }
  }

  private removeChat(): void {
    const chatElement = document.getElementById('n8n-chat');
    if (chatElement) {
      chatElement.innerHTML = '';
    }
    this.chatInitialized = false;
  }
}
